/*
 * Copyright (c) 2021. American Express Company
 */

// 3rd party
import React, { Component, ReactComponentElement } from 'react';

// models and services
import { PersonIconViewModel } from 'src/types/view-models/person-icon.view.model';

// stylesheets
import { BW_PHANT_URL } from '../../config';
import { GlyphAccount } from '@americanexpress/dls-react';
import styles from './PersonIcon.module.scss';

export default class PersonIcon extends Component<PersonIconViewModel> {
    public override render(): ReactComponentElement<any> {
        const width: number = this.props.width || 80;

        if (this.props.person) {
            let avatar: JSX.Element;
            switch (true) {
                case !this.props.person.photos || !this.props.person.photos.length:
                    avatar = (
                        <div className="generic-person" style={{ width, height: width }}>
                            <GlyphAccount />
                        </div>
                    );
                    break;
                case this.props.person.photos[0].absoluteUrl != null:
                    avatar = (
                        <img
                            src={this.props.person.photos[0].absoluteUrl}
                            alt={this.props.person.nickname || 'person avatar'}
                            width={width}
                            height={width}
                            className="user-avatar"
                        />
                    );
                    break;
                case this.props.person.photos[0].relativeUrl != null:
                    avatar = (
                        <img
                            src={`${BW_PHANT_URL}/${this.props.person.photos[0].relativeUrl}`}
                            alt={this.props.person.nickname || 'person avatar'}
                            width={width}
                            height={width}
                            className="user-avatar"
                        />
                    );
                    break;
            }

            return (
                <div
                    className={this.getClasses()}
                    onClick={this.props.onClick}
                    key={`icon-${this.props.person.personUid}`}
                >
                    {avatar}
                </div>
            );
        } else {
            return null;
        }
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        classes.push(styles.personIcon);

        return classes.join(' ');
    }
}
